<template>
  <textColor />
  <listingTypography />
  <div class="col-sm-12 text-start">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Blockquotes</h3><span>Add a <code>&lt;footer class="blockquote-footer"&gt;</code> for identifying the source.
          Wrap the name of the source work in <code>&lt;cite&gt;</code>.</span>
      </div>
      <div class="card-body">
        <p class="sub-title">Naming a source</p>
        <div class="figure d-block">
          <blockquote class="blockquote">
            <p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
          </blockquote>
          <div class="blockquote-footer">Someone famous in
            <cite title="Source Title">Source Title</cite>
          </div>
        </div>
        <p class="sub-title">Alignment Center</p>
        <div class="figure text-center d-block">
          <blockquote class="blockquote">
            <p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
          </blockquote>
          <div class="blockquote-footer">Someone famous in
            <cite title="Source Title">Source Title</cite>
          </div>
        </div>
        <p class="sub-title">Alignment Right</p>
        <div class="figure text-end d-block">
          <blockquote class="blockquote">
            <p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
          </blockquote>
          <div class="blockquote-footer">Someone famous in
            <cite title="Source Title">Source Title</cite>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import listingTypography from "./listingTypography.vue"
import textColor from "./textColor"
export default {
  components: {
    listingTypography, textColor
  }
}
</script>